import React, { Component } from 'react';
import Noconnection from '../../screens/noconnectionscreen/noconnection.component';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by Error Boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
     
      return (
        <div>
            <Noconnection/>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
